var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"card-body--no-padding"},[_c('img',{staticClass:"img-fluid w-100 header__img",attrs:{"src":_vm.header.image,"alt":"404"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }